import {Button, Dialog, DialogActions, DialogContent, Stack, Typography} from "@mui/material";
import {MyDialogTitle} from "@/components/dialog/MyDialogTitle.tsx";
import {z} from "zod";
import {zodResolver} from "@hookform/resolvers/zod";
import {FormProvider, useForm} from "react-hook-form";
import {FormTextField} from "@/components/form/FormTextField.tsx";
import {useCallback} from "react";
import {BankAccountFragmentFragment, useCreateBankAccountMutation,} from "@/graphql/graphql";
import toast from "react-hot-toast";

interface CreateNewBankAccountDialogProps {
  open: boolean;
  onClose: () => void;
  onCreateSuccess?: (value: BankAccountFragmentFragment) => Promise<void>;
}

const schema = z.object({
  bankName: z.string(),
  branchName: z.string(),
  accountHolderName: z.string(),
  accountNumber: z.string(),
  accountType: z.string(),
  remarks: z.string().nullish(),
})

export function CreateNewBankAccountDialog(
  {open, onClose, onCreateSuccess}: CreateNewBankAccountDialogProps
) {
  
  const create = useCreateBankAccountMutation()
  
  const form = useForm({
    defaultValues: {
      accountHolderName: '',
      accountNumber: '',
      accountType: '普通',
      bankName: '',
      branchName: '',
      remarks: ''
    },
    resolver: zodResolver(schema),
    mode: "onChange"
  })
  
  const onSubmit = useCallback(async (
    value: z.infer<typeof schema>
  ) => {
    const toastId = toast.loading('作成中...')
    await create.mutateAsync({
      input: value
    }).then(
      (res) => {
        if (res.createBankAccount) {
          toast.success('作成しました', {id: toastId})
          onClose()
          if (onCreateSuccess) {
            onCreateSuccess(res.createBankAccount)
          }
        }
      }
    ).catch(
      () => {
        toast.error('作成に失敗しました', {id: toastId})
      }
    )
  }, [create, onClose, onCreateSuccess])
  
  return <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
    <MyDialogTitle
      onClose={onClose}
    >
      新規作成
    </MyDialogTitle>
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <DialogContent>
          <Stack spacing={1}>
            
            <Typography variant={'formLabel'}>銀行名</Typography>
            <FormTextField name={'bankName'} control={form.control} placeholder={'三菱UFJ銀行'}/>
            <Typography variant={'formLabel'}>支店名</Typography>
            <FormTextField name={'branchName'} control={form.control} placeholder={"渋谷支店"}/>
            <Typography variant={'formLabel'}>名義</Typography>
            <FormTextField name={'accountHolderName'} control={form.control} placeholder={'田中太郎'}/>
            <Typography variant={'formLabel'}>口座番号</Typography>
            <FormTextField name={'accountNumber'} control={form.control} placeholder={'1234567'}/>
            <Typography variant={'formLabel'}>口座種別</Typography>
            <FormTextField name={'accountType'} control={form.control} placeholder={'普通'}/>
            <Typography variant={'formLabel'}>備考</Typography>
            <FormTextField name={'remarks'} control={form.control} placeholder={'備考'}/>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>キャンセル</Button>
          <Button type={'submit'} variant={'contained'} disabled={!form.formState.isValid} onClick={() => {
            console.log(form.getValues())
          }}>作成</Button>
        </DialogActions>
      </form>
    </FormProvider>
  
  </Dialog>
}
